<div class="live-status" *ngIf="hasEvent">

  <div class="live-status__item live-status__item--report">
    <i class="live-status__dot" [ngClass]="'live-status__dot--' + report.severity"></i>
    <div class="live-status__text">
      <span class="live-status__label">{{report.label}}</span>
      <strong class="live-status__value" *ngIf="report.elapsedLabel">{{report.elapsedLabel}}</strong>
    </div>
  </div>

  <div class="live-status__item">
    <i class="fas fa-stopwatch live-status__icon"></i>
    <div class="live-status__text">
      <span class="live-status__label">{{idle.label}}</span>
      <strong class="live-status__value" [ngClass]="{'live-status__value--muted': !idle.available}">
        {{idle.value}}
      </strong>
    </div>
  </div>

  <div class="live-status__item" *ngIf="source || novelty">
    <i class="fas fa-satellite-dish live-status__icon"></i>
    <div class="live-status__text">
      <span class="live-status__label">{{source || 'Fuente GPS'}}</span>
      <strong class="live-status__value" *ngIf="novelty" [title]="novelty">{{novelty}}</strong>
    </div>
  </div>

</div>
